export enum SwapsToShow {
    Pending = 1,
    Past = 2
}